import React, {useEffect, useState, useMemo, useCallback} from "react";
import {useTranslation} from "react-i18next";
import {inject, observer} from "mobx-react";
//local
import {Layout} from "components/UI/layout";
import {Explanation} from "components/Explanation";
import {IconContract} from "components/icons";
import ContractsToUsTableHead from "./components/ContractsToUsTableHead";
import {Preloader} from "components/Preloader";
import {defaultCreatedFieldSearch} from "constants/user.consts";
import ContractsToUsTableItem from "./components/ContractsToUsTableItem";
import EmptyData from "components/EmptyData";
import {useSavedFilters} from "helpers/userHooks";
import {color} from "constants/color.consts";

const ContractsToUsPage = inject("store")(
  observer(({store: {auth, seller}}) => {
    const {loading, contracts} = seller;
    const {user} = auth;
    const {t} = useTranslation();

    const isShowContractNumber = user?.ActiveOrganization?.showContractNumber;
    const [selectedProjectId, setSelectedProjectId] = useState(null);

    const filterContracts = useMemo(
      () =>
        selectedProjectId && contracts?.length
          ? contracts.filter(
              (item) => item.Offer?.Proposal?.Request?.Project?.id === selectedProjectId
            )
          : contracts,
      [contracts, selectedProjectId]
    );

    const projects = useMemo(
      () =>
        contracts.length
          ? contracts
              .filter((item) => item.Offer?.Proposal?.Request?.Project)
              .map((item) => item.Offer?.Proposal?.Request?.Project)
              .reduce(
                (rezProjects, item) =>
                  rezProjects.find((val) => val.id === item.id)
                    ? [...rezProjects]
                    : [...rezProjects, item],
                []
              )
          : [],
      [contracts]
    );

    const [filters, setFilter] = useSavedFilters({
      key: "contractsPageFiltersSeller",
      defaultValue: defaultCreatedFieldSearch,
      allowedKeys: ["name", "field", "direction"],
    });

    const getContracts = useCallback(
      () => seller.getContracts(filters),
      [seller, filters]
    );

    useEffect(() => {
      getContracts();
    }, [getContracts]);

    return (
      <Layout>
        <div className="our-contracts">
          <div className="content-block_header pa-4 pl-5">
            <IconContract color={color.black} />
            <h3 className="content-block_title __uppercase">{t("OUR_CONTRACTS")}</h3>
          </div>
        </div>
        {loading && <Preloader addClass="preloader500" />}
        {!loading && (
          <div className="our-contracts content-block_wrapper">
            {!!contracts?.length ? (
              <>
                <ContractsToUsTableHead
                  projects={projects}
                  filters={filters}
                  isBuyer={false}
                  showContractNumber={isShowContractNumber}
                  onChangeProject={(value) => setSelectedProjectId(value)}
                  onChangeOrder={(value) => setFilter({...filters, ...value})}
                />
                {!!filterContracts.length ? (
                  filterContracts.map((contract) => (
                    <ContractsToUsTableItem
                      key={contract.id}
                      contract={contract}
                      showContractNumber={isShowContractNumber}
                      isFinished={!!contract.isSigned}
                    />
                  ))
                ) : (
                  <EmptyData addClass="empty-data pt-4" />
                )}
              </>
            ) : (
              <Explanation text="BEAVER_SAYS_BUYER_HAS_NO_CONTRACTS" fitWidth center />
            )}
          </div>
        )}
      </Layout>
    );
  })
);

export default ContractsToUsPage;
